import { render, staticRenderFns } from "./Recognition.vue?vue&type=template&id=45d4d2b6&scoped=true&"
import script from "./Recognition.vue?vue&type=script&lang=ts&"
export * from "./Recognition.vue?vue&type=script&lang=ts&"
import style0 from "./Recognition.vue?vue&type=style&index=0&id=45d4d2b6&scoped=true&lang=scss&"
import style1 from "./Recognition.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d4d2b6",
  null
  
)

export default component.exports